export const payFrequencies = [
    {value: 'weekly', label: 'Weekly'}, 
    {value: 'biWeekly', label: 'Bi-Weekly'}, 
    {value: 'monthly', label: 'Monthly'}
]